/**
 * Downloads a url through a temporary anchor. The anchor is attached to the
 * document because Firefox ignores clicks on detached anchors. An empty
 * `download` keeps the server's file name; browsers ignore it cross-origin
 * (e.g. presigned S3 urls), where the response headers decide.
 */
export const downloadUrl = (url: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = '';
  document.body.appendChild(link);
  link.click();
  link.remove();
};
